import { IOptions } from '../../constants/types/common.types'
import { ONE_DAY } from '../../constants/timeslot'

const nextDay = (date: Date) => new Date(date).getTime() + ONE_DAY - 1

const formatDateQuery = (dates: Date[]) => {
  const [startDate, endDate] = dates
  const dateTo = endDate ? `&dateTo=${nextDay(endDate)}` : ''
  const dateFrom = startDate ? `&dateFrom=${new Date(startDate).getTime()}` : ''
  return dateTo + dateFrom
}

const formatAllQueryURL = (offset: number, speciality: IOptions[], inputText: string): string => {
  const offsetFormed = `&offset=${offset}`
  const specialityFormed = speciality.map((item) => `&SpecialityId=${String(item.value)}`).join('')
  const subString = inputText && `&subStringName=${inputText.toLowerCase()}`
  return offsetFormed + subString + specialityFormed
}

const formatLectorSingleURL = (
  lectorId: number,
  theme: IOptions[],
  types: string[],
  dates: Date[],
  inputText: string
): string => {
  const lecturId = `&LecturId=${lectorId}`

  const materialTypeString = types.length
    ? `&materialType=${JSON.stringify(
        types.map((type) => {
          if (type === 'video') return 'article'
          return type
        })
      )}`
    : ''
  const articleTypeString = types.length
    ? `&ArticleTypeId=${JSON.stringify(
        types.map((type) => {
          if (type === 'article') return 1
          if (type === 'video') return 2
          if (type === 'webinar') return
        })
      )}`
    : ''
  const dateQuery = formatDateQuery(dates)
  const themesFormed = theme.length
    ? `&Theme=${JSON.stringify(theme.map(({ label }) => `${label}`))}`
    : ''
  const subString = inputText && `&subStringName=${inputText.toLowerCase()}`

  return lecturId + dateQuery + subString + themesFormed + materialTypeString + articleTypeString
}

const formatClinicalCasesURL = (
  offset: number,
  specialities: IOptions[],
  inputText: string
): string => {
  const offsetFormed = `&offset=${offset}`
  const specialitiesQuery = specialities?.length
    ? `&SpecialityId=[${specialities.map(({ value }) => value).join(',')}]`
    : ''
  const subString = inputText && `&subStringName=${inputText.toLowerCase()}`
  return offsetFormed + subString + specialitiesQuery
}

const formatBaseLibraryURL = (
  inputText: string,
  dates: Date[],
  lecturs: IOptions[],
  theme: IOptions[],
  specialities?: IOptions[]
): string => {
  const subString = inputText && `&subStringName=${inputText.toLowerCase()}`

  const dateQuery = formatDateQuery(dates)

  const lectorQuery = lecturs?.length
    ? `&LecturId=[${lecturs.map(({ value }) => value).join(',')}]`
    : ''

  const specialitiesQuery = specialities?.length
    ? `&SpecialityId=[${specialities.map(({ value }) => value).join(',')}]`
    : ''

  const themeQuery = theme?.length
    ? `&Theme=${JSON.stringify(theme.map(({ label }) => `${label}`))}`
    : ''
  return subString + dateQuery + lectorQuery + themeQuery + specialitiesQuery
}

const formatProgramQueryURL = (
  offset: number,
  speciality: IOptions[],
  points: IOptions[],
  lecturs: IOptions[],
  inputText: string
): string => {
  const offsetFormed = `&offset=${offset}`
  const specialityFormed = speciality.length
    ? `&SpecialityId=[${speciality.map((item) => item.value).join(',')}]`
    : ''
  const pointsFormed = points?.length
    ? `&points=[${points.map(({ value }) => value).join(',')}]`
    : ''
  const lectorQuery = lecturs?.length
    ? `&LecturId=[${lecturs.map(({ value }) => value).join(',')}]`
    : ''
  const subString = inputText && `&subStringName=${inputText.toLowerCase()}`
  return offsetFormed + subString + specialityFormed + pointsFormed + lectorQuery
}

export {
  formatDateQuery,
  formatAllQueryURL,
  formatLectorSingleURL,
  formatClinicalCasesURL,
  formatBaseLibraryURL,
  formatProgramQueryURL,
}
